import React, { Component } from 'react';
import ReactTable from 'react-table';

class TableContent extends Component {

    render() {
        return (
            <ReactTable
                data={this.props.listaConteudo}
                columns={this.props.columns}
                onFetchData={this.refreshTable}
                manual
                pageSize={this.props.listaConteudo.length}
                showPagination={false}
                loading={this.props.loading}
                className="-striped -highlight"
                headerClassName="ebs-table-header"
                getTrProps={(state, rowInfo, column, instance) => {
                    if (rowInfo) {
                        return {
                            style: {
                                // background: rowInfo.original.novo ? '#007bff' : '',
                                // color: rowInfo.original.novo ? 'white' : '',
                                color: rowInfo.original.novo ? '#28a745' : '',
                                fontWeight: rowInfo.original.novo ? 'bold' : ''
                            }
                        }
                    }
                    return {};
                }}
            />

        )
    }
}

export default TableContent;